import { DOCUMENT } from "@angular/common";
import { Component, Inject } from "@angular/core";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { OktaAuthService } from "@okta/okta-angular";
import { Observable } from "rxjs";
import { map, switchMap, tap } from "rxjs/operators";
import { QuickbookService } from "../quickbook-service";

@Component({
  template: "",
})
export class OAuth2CallbackComponent {
  constructor(
    activatedRoute: ActivatedRoute,
    @Inject(DOCUMENT) document: Document,
    private oktaAuthService: OktaAuthService,
    private quickbookService: QuickbookService,
    private router: Router,
  ) {
    activatedRoute.queryParamMap
      .pipe(switchMap(queryParams => this.handleCallback(queryParams)))
      .pipe(tap(state => document.location.href = state))
      .subscribe();
  }

  private handleCallback(paramMap: ParamMap): Observable<string> {
    let code = this.getServerResponseParam("code", paramMap);
    let state = decodeURIComponent(this.getServerResponseParam("state", paramMap));

    return this.oktaAuthService.$authenticationState.pipe(switchMap(_ => this.quickbookService.getTokens(code).pipe(map(_ => state))));
  }

  private getServerResponseParam(param: string, paramMap: ParamMap): string {
    let result = paramMap.get(param) || "";

    if (result == "") {
      this.router.navigateByUrl("/?oauth2-error");
    }

    return result;
  }
}